import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue.pop() : '';
}

const LoginRoute = ({ children }) => {

    // const getlocalStorageItem = () =>{
    //     let userId = localStorage.getItem("PCX_STORE_admin_ID");
    //     if(userId){
    //         return JSON.parse(userId);
    //     }else{    
    //         return null;
    //     }

    // }
    //   const adminData = getlocalStorageItem();
    //   const [data, setData] = useState([]);

    //     useEffect(() => {
    //         if(adminData?._id){
    //             fetch(`https://api.wlffinance.org/api/admin/role/view/${adminData?._id}`, {
    //                 method: 'GET',
    //             })
    //                 .then((res) => res.json())
    //                 .then((data) => {
    //                     setData(data.data)
    //                 })
    //         }   
    //     }, [])




    const location = useLocation();
    const [token, setToken] = useState(getCookie('PCX_STORE_admin_token'));

    if (!token) {
        return children;

    }
    else if (token) {
        return <Navigate to='/admin/dashboard' state={{ from: location }} replace ></Navigate>

    }





}

export default LoginRoute;